import { Friend } from "./Friend";

export function FriendList({ friends, onSelection, selectedFriend }) {
  return (
    <>
      <ul>
        {friends.map((friend) => (
          <Friend
            onSelection={onSelection}
            selectedFriend={selectedFriend}
            friend={friend}
            key={friend.id}
          />
        ))}
      </ul>
    </>
  );
}
